define('TescoMobile_Catalog/js/model/deal',[], function () {
  'use strict';

  return {
    isUpdatingOptions: false,
    selectedTariffSku: false,
    tariffSelectionValue: '',
    puf: 0,
    tenure: 0,
    deviceFullPrice: 0,
    deviceMonthlyPrice: 0,
    tariffSelectionData: {}
  };
});

